import { render } from "./RejectedLiquidations.vue?vue&type=template&id=606d14c0"
import script from "./RejectedLiquidations.vue?vue&type=script&lang=js"
export * from "./RejectedLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__